<div class="rti-local-special-card"
     [hidden]="hidden"
     [class.disabled]="disabled">
  <mat-card [attr.id]="cid" (click)="onCard($event)">
    <mat-card-content>
      <div class="rti-local-special-card-content" rti-anchor [ngStyle]="data.style"></div>
    </mat-card-content>
    <mat-card-actions class="rti-local-special-card-actions" [hidden]="actions.length === 0">
      <a href="#"
         class="rti-local-special-card-action"
         (click)="action.onClick($event)"
         *ngFor="let action of actions">{{action?.label}}</a>
    </mat-card-actions>
  </mat-card>
</div>
